import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const DrawerStyles = (theme: Theme) => ({
  drawerBackdrop: {
    position: "fixed" as const,
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.25)",
    backdropFilter: "blur(4px)",
    transition: "opacity .3s ease, visibility .3s ease",
    zIndex: 999,
  },
  drawer: {
    position: "fixed" as const,
    top: 0,
    insetInlineEnd: 0,
    height: "100%",
    width: "min(86vw, 360px)",
    backgroundColor: theme.background,
    color: theme.text,
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    borderInlineStart: `1px solid ${theme.primary}22`,
    paddingTop: "max(12px, env(safe-area-inset-top))",
    paddingBottom: "max(12px, env(safe-area-inset-bottom))",
    display: "flex",
    flexDirection: "column" as const,
    transition: "transform .3s ease",
    zIndex: 1000,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.9rem 1rem",
    borderBottom: `1px solid ${theme.primary}22`,
    fontWeight: 600,
  },
  drawerList: {
    flexGrow: 1,
    overflowY: "auto" as const,
    padding: "0.75rem 1rem",
    display: "flex",
    flexDirection: "column" as const,
    gap: 6,
  },
  drawerLink: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    padding: "0.9rem 0.75rem",
    borderRadius: 10,
    textDecoration: "none",
    color: theme.text,
    opacity: 0.95,
    transition: "background-color .2s ease, color .2s ease, transform .1s ease",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "15px",
    fontWeight: 500,
  },
  drawerLinkHover: { backgroundColor: theme.hover },
  drawerLinkActive: {
    backgroundColor: theme.hover,
    color: theme.text,
    fontWeight: 700,
  },

  // Footer container
  drawerFooterWrap: {
    marginTop: "auto",
    padding: "0 1rem 10px",
    marginButtom: 30, // (kept as provided)
  },

  // Reusable <a/> base for CTAs
  anchorBase: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 44,
    borderRadius: 12,
    textDecoration: "none",
    fontWeight: 600,
    fontFamily: "'Poppins', sans-serif",
    padding: 5,
    transition: "filter .15s ease, transform .05s ease",
    userSelect: "none" as const,
    WebkitTapHighlightColor: "transparent",
  },

  // Primary CTA (solid)
  ctaPrimary: {
    background: theme.primary,
    color: theme.hoverText,
  },

  // Secondary CTA (outlined / subtle bg)
  ctaSecondary: {
    background: `${theme.primary}14`,
    color: theme.text,
    border: `1px solid ${theme.primary}`,
  },

  // Footer meta row (© …)
  footerMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    opacity: 0.7,
    fontSize: 12,
    marginBottom: 25,
    fontFamily: "'Poppins', sans-serif",
  },

  // (Optional) generic button style if you want to move the close button later
  iconBtn: {
    background: `${theme.primary}14`,
    border: "none",
    borderRadius: 10,
    width: 34,
    height: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    cursor: "pointer",
  },

  // Light/Dark hover helpers
  drawerLinkHoverLight: { backgroundColor: "rgba(0,0,0,0.06)" },
  drawerLinkHoverDark: { backgroundColor: "rgba(255,255,255,0.08)" },
});
